import ActionTypes from '../constants';

const initialState = {
    users: {},
    permissions: {},
    permissionsById: {},
    user: {}
    // loading: false,
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETUSERSUCCESS:
            return {
                ...state,
                users: action.payload,
            }
        case ActionTypes.GETPERMISSIONSSUCCESS:
            return {
                ...state,
                permissions: action.payload,
            }
        case ActionTypes.GETPERMISSIONSBYIDSUCCESS:
            return {
                ...state,
                permissionsById: action.payload,
            }
        case ActionTypes.GETUSERBYIDSUCCESS:
            return {
                ...state,
                user: action.payload,
            }
        default:
            return state;
    }
}

export default userReducer;